import * as Yup from 'yup'
import { COURIER } from 'domains/seller-inbound/constants/seller-inbound-pickup-constants'

const ConsignmentInboundRequestBulkSchedulePickupSchema = Yup.object().shape({
  scheduled_at    : Yup.date().required('Required'),
  tracking_number : Yup.string(),
  courier         : Yup.string().oneOf(
    Object.values(COURIER),
    `Harus satu dari ${Object.values(COURIER).join(', ')}`
  ).required('Required')
})

export default ConsignmentInboundRequestBulkSchedulePickupSchema